<template>
  <div class="vehicleBox">
    <el-card>
      <el-row>
        <el-col :span="24" class="unitTitle">
          包车计费
        </el-col>
      </el-row>

      <el-form ref="refVehicleForm" :model="form" label-width="30px" :rules="vehicleRules">
        <el-row :gutter="10">
          <el-col :span="11">
            <vxe-table
              ref="xTable"
              row-id="vehicleId"
              size="small"
              border
              keep-source
              :data="form.tableData"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              @edit-closed="saveEvent"
            >
              <vxe-table-column field="price" title="包车价/元" :edit-render="{ name: 'input',autoselect: true }" />
              <vxe-table-column field="limitEnd" title="距离内/Km" :edit-render="{ name: 'input',autoselect: true }" />
            </vxe-table>

          </el-col>

          <el-col :span="1" class="iconCount margintop">
            <i class="el-icon-plus" />
          </el-col>
          <el-col :span="7" class="contentBox margintop">
            <!-- 公里单价 -->
            <el-col :span="9">
              <el-tooltip class="item" effect="dark" content="公里单价" placement="top">
                <el-form-item label-width="0" prop="unitPrice">
                  <el-input v-model.number="form.unitPrice" placeholder="公里单价" type="number" min="0.00" step="0.01">
                    <i slot="suffix">元/Km</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="2" class="iconCount">
              <i class="el-icon-close" />
            </el-col>
            <el-col :span="13" class="contentBox">
              <el-tooltip class="item" effect="dark" content="超出公里数" placement="top">
                <el-form-item label-width="0">
                  <el-input placeholder="公里数-起步公里数" disabled>
                    <i slot="suffix">Km</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>
          </el-col>

          <el-col :span="1" class="iconCount margintop">
            <i>=</i>
          </el-col>

          <el-col :span="4" class="contentBox margintop">
            <el-col :span="24">
              <el-tooltip class="item" effect="dark" content="包车运费" placement="top">
                <el-form-item label-width="0">
                  <el-input placeholder="包车运费" disabled>
                    <i slot="suffix">元</i>
                  </el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>

          </el-col>
        </el-row>

        <!-- 车型费用 -->
        <el-row class="carPrice">
          <el-col :span="24" class="unitTitle" style="margin-top:15px;">车型费用
            <el-button type="primary" plain style="float:right;width:200px" @click="addCarPrice">+ 增加包车计费</el-button>
          </el-col>

        </el-row>
        <!-- 车型费用 -->
        <div v-for="(item, index) in form.domains" :key="item.key" class="rowBorder">
          <el-row :gutter="10">
            <el-col :span="11">
              <el-form-item label-width="0" style="margin:0;" :prop="'domains.' + index + '.routelineCode'">
                <el-select v-model="item.routelineCode" placeholder="请选择车型" style="width:100%;">
                  <el-option
                    v-for="(item1, index1) in item.vehicleOptions"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i>=</i>
            </el-col>
            <el-col :span="7" class="contentBox">
              <el-form-item label-width="0" style="margin:0;" :prop="'domains.' + index + '.points'" :rules="vehicleRules.points">
                <el-input v-model.number="item.points" type="number" min="0.00" step="0.01">
                  <i slot="suffix">%</i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i class="el-icon-close" />
            </el-col>
            <el-col :span="4" class="contentBox">
              <el-col :span="priceWidth">
                <el-tooltip class="item" effect="dark" content="包车费用" placement="top">
                  <el-form-item label-width="0" style="margin:0;">
                    <el-input placeholder="包车运费" disabled>
                      <i slot="suffix">元</i>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <template v-if="isRemove">
                <el-col :span="2">
                  <el-button type="text" @click="removeCarPrice(item)">删除</el-button>
                </el-col>
              </template>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: "VehiclePrice",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      priceWidth: 22,
      isRemove: false,
      dictData:[],
      vehicleData:[],
      vehicleRules:{
        points: [{ type: "number", message: "百分比必须为数字值"  }]
      },
      form: {
        tableData: [
          { price: 10, limitEnd: 20 },
          { price: 50, limitEnd: 80 },
          { price: 100, limitEnd: 160 }
        ],
        unitPrice: '',
        domains: [
          {
            routelineCode: "",
            vehicleOptions:  this.vehicleData,
            points: ""
          }
        ]
      },
    };
  },

  created() {
  },
  mounted() {
      this.getVehicleType();

  },
  methods: {
    getVehicleType(){
        request({
            url: "/ntocc-basic-api/dict/listDict",
            method: "get",
            params: {types:"vehicleClassification"}
        }).then(response => {
            this.dictData = response.data[0].dictList
            this.dictData.map(item => {
                this.vehicleData.push(
                    Object.assign({}, {value:item.code, label:item.name})
                )
            });
            this.form.domains[0].vehicleOptions=this.vehicleData;
        })
    },
    addCarPrice() {
        this.form.domains.push({
          key: Date.now(),

            routelineCode: "",
            vehicleOptions:  this.vehicleData,
            points: ""
        });
        this.priceWidth = 19;
        this.isRemove = true;
    },
    // 删除当前包车价格
    removeCarPrice(item) {
      var delId;
      this.form.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.form.domains.length > 1) {
        this.form.domains.splice(delId, 1);
      } else {
        this.priceWidth = 22;
        this.isRemove = false;
        this.$refs.refVehicleForm.resetFields();

      }
    },
     resetVehicleForm() {
        this.$refs.refVehicleForm.resetFields();
        this.form.domains.splice(1);
        this.form.tableData = [
          { price: 10, limitEnd: 20 },
          { price: 50, limitEnd: 80 },
          { price: 100, limitEnd: 160 }
        ]

      }

  }
};
</script>
<style lang="scss" scoped>

.rowBorder {
  margin-bottom: 10px;
  background: rgba(172, 217, 248, 0.2);
  padding: 10px 20px;
  margin-top: 10px;
}
.conputedStyle {
  margin-top: 60px;
  position: relative;
  z-index: 4;
}
.iconCount {
  padding-top: 10px;
  text-align: center;
}
.addBtn {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 3;
}
.inputTable {
  margin: 0;
}

.carPrice {
  position: static !important;
}
.margintop {
  margin-top: 58px;
}
.unitTitle {
  font-size: 14px;
  font-weight: 700;
  color: #606266;
  // margin-bottom: 10px;
  padding: 0 20px;
}
</style>
